import { RESET_PASSWORD_IS_LOADING } from '../actions/login';

const initial = {
  isLoading: false,
};

const setLoading = (state, { payload }) => ({ ...state, isLoading: payload });

const REDUCERS = {
  RESET_PASSWORD_IS_LOADING: setLoading,
};

export default (state = initial, action) =>
  (action.type in REDUCERS ? REDUCERS[action.type](state, action) : state);
